import clsx from "clsx";
import { TestimonialDto } from "dtos/content/TestimonialDto";
import { CardPlaceholder } from "components/placeholders/CardPlaceholder";

export const TestimonialsDisplay = (props: { testimonials?: Array<TestimonialDto> }) => {
    const { testimonials } = props;

    return (
        <div className="vstack gap-4 gap-lg-5 text-center text-dark">
            <h2 className="text-white">What do teachers say?</h2>

            {testimonials ? (
                <div className="carousel slide" id="carousel-testimonials" data-bs-ride="carousel">
                    <div className="carousel-indicators mb-n3">
                        {testimonials.map((t, index) => (
                            <button
                                key={t.id}
                                type="button"
                                data-bs-target="#carousel-testimonials"
                                data-bs-slide-to={index}
                                className={clsx(index === 0 && "active")}
                            >
                                <span className="visually-hidden">{t.quote}</span>
                            </button>
                        ))}
                    </div>

                    <div className="carousel-inner">
                        {testimonials.map((t, index) => (
                            <div className={clsx("carousel-item", index === 0 && "active")} key={t.id}>
                                <figure className="rounded vstack gap-3 testimonial px-4 px-lg-0">
                                    <blockquote className="blockquote fs-4 fw-bold text-white">"{t.quote}"</blockquote>
                                    <figcaption className="blockquote-footer text-white">{t.person}</figcaption>
                                </figure>
                            </div>
                        ))}
                    </div>

                    <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#carousel-testimonials"
                        data-bs-slide="prev"
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>

                    <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#carousel-testimonials"
                        data-bs-slide="next"
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            ) : (
                <CardPlaceholder />
            )}
        </div>
    );
};
